import React from "react";

export const AppContext = React.createContext({
    helpActive: false,
    hideForDemo: false,
    hideForProd: true,
    toggleHelp: () => {}
});
